import { useContext } from 'react'
import { LinkType, StyledLink } from '../../..'
import { AuthContext } from '../../../../contexts'

export const DesktopLogoutLink = () => {
  const { logOut } = useContext(AuthContext)

  return (
    <StyledLink
      type={LinkType.BASIC}
      onClick={logOut}
      href="#"
      translationId="pages.logoutPage.logout"
    />
  )
}
